const loginWindow = {
  // 用户名密码注册接口-带滑块验证-极验
  registerSlider: `/authApi/auth/v3/register/byUsername`,
  // registerSlider: `/authApi/auth/v2/register/byUsername`,
  // 根据token绑定手机号
  bindPhoneByToken: `/authApi/auth/v1/login/bindPhoneByToken`,
  // 加密的用户名密码登录
  bypassword: `/authApi/auth/v3/login/safe/byPwd`,
  // 手机验证码登录JAVA-极验
  phoneLoginCaptcha: `/authApi/auth/v3/login/byPhoneCode`,
  // phoneLoginCaptcha: `/authApi/auth/v1/login/byPhoneCode`,
  // 根据账号获取手机验证码
  accountPhoneCode: `/userApi/v1/UserAccount/accountPhoneCode`,
  // 根据用户名获取手机号前四位
  getPhonePreByUsername: `/userApi/v1/UserInfo/getPhonePreByUsername`,
  // 新设备验证JAVA
  verify: `/authApi/auth/confirm/login/verify`,
  // 推送类型消息JAVA
  verifyMessage: `/authApi/auth/obtain/push/message`,
  // 授权 加密的用户名密码登录
  confirmBypassword: `/authApi/auth/confirm/login/safe/byPwd`,
  // 微软注册上报 -- 白金泽
  clickBing: `/authApi/trilateral/bing/clickBing`,
  // 激活数据上报第三方(优酷激活上报) -- 白金泽
  activeReport: `/authApi/trilateral/v1/active/data/report`,
  // 注册数据上报第三方(优酷+搜狗注册上报) -- 白金泽
  registerReport: `/authApi/trilateral/v1/register/data/report`
};

export default loginWindow;
